import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/site";

const SiteContext = createContext(null);

const EMPTY = {
  settings: {},
  services: [],
  products: [],
  advantages: [],
  portfolio: [],
  testimonials: [],
  faqs: [],
  stats: [],
};

export function SiteProvider({ children }) {
  const [content, setContent] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/content");
      setContent({ ...EMPTY, ...data });
    } catch (e) {
      setContent(EMPTY);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const wa = useCallback(
    (message) => {
      const settings = content?.settings || {};
      const number = settings.wa_number || "6281289001234";
      const text = message || settings.wa_message || "Halo, saya ingin berkonsultasi mengenai pembuatan Cold Storage.";
      return `https://wa.me/${number}?text=${encodeURIComponent(text)}`;
    },
    [content]
  );

  return <SiteContext.Provider value={{ content, refresh, wa }}>{children}</SiteContext.Provider>;
}

export function useSite() {
  return useContext(SiteContext);
}
